export default __webpack_public_path__ + "assets/425d2e.webp";